// NPM Imports
import React, { Component } from "react";
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";
import moment from "moment";

export default class AgDatePicker extends Component {
  state = {
    selectedDate: moment(this.props.value),
  };

  getValue() {
    return this.state.selectedDate;
  }

  handleChange = date => {
    const selectedDate = date;
    this.setState(() => ({ selectedDate }));
  };

  // Ag-grid needs this function to know the component is rendered as a popup
  isPopup() {
    console.debug(this.state);
    return true;
  }

  render() {
    return (
      <DatePicker
        selected={this.state.selectedDate}
        onChange={this.handleChange}
        data-test="datepicker"
      />
    );
  }
}

AgDatePicker.propTypes = {
  // Props
  value: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/AgGridCellEditor/DatePicker.js